(ns ycweb.weber.graph)

(defn graph-div [data]
  [:div
   {:class "graph"
    :data (pr-str data)}
   "Graph"])

;; https://developers.google.com/chart/interactive/docs/reference#dataparam
(def coltypes
  [:boolean :number :string :date :datetime :timeofday])

;; Timeofday value needs to be a vector with [h m s] or [h m s ms]
(def types
  [:bar :pie :column :histogram :line :stepped :scatter])

(defn h [title valuefn & {:keys [type id pattern p] :as opts}]
  (cond->
    (assoc opts
      :label title
      :f (if (keyword? valuefn) (fn [r] {:v (valuefn r 0)}) valuefn))
    (keyword? type) (assoc :type (name type))
    (not type) (assoc :type "number")))

(defn build-data [data headers]
  {:cols (map #(dissoc % :f) headers)
   :rows (map (comp (fn [r] {:c r}) (apply juxt (map :f headers))) data)})

(defn graph [data headers options & {:keys [refreshtime dataurl graphtype] :as opts}]
  (graph-div
    (assoc
      opts
      :data (build-data data headers)
      :options options)))